module.exports = __webpack_public_path__ + "img/Back.2d135e5a.svg";